import MessageCollection from './MessageCollection';
// import i18n from '@/vueI18n';

export default class ValidatorMessageBag {
  constructor() {
    this.warnings = new MessageCollection();
    this.errors = new MessageCollection();
    this.success = new MessageCollection();
  }

  hasErrors() {
    return this.errors.length !== 0;
  }

  hasError(propertyName) {
    return propertyName in this.errors;
  }

  hasWarnings() {
    return this.warnings.length !== 0;
  }

  hasWarning(propertyName) {
    return propertyName in this.warnings;
  }

  hasSuccesses() {
    return this.success.length !== 0;
  }

  hasSuccess(propertyName) {
    return propertyName in this.success;
  }

  addError(propertyName, error) {
    this.errors.add(propertyName, error);
  }

  addWarning(propertyName, warning) {
    this.warnings.add(propertyName, warning);
  }

  addSuccess(propertyName, success) {
    this.success.add(propertyName, success);
  }

  addByType(key, type, message) {
    if (type === 'error') {
      this.addError(key, message);
    } else if (type === 'warning') {
      this.addWarning(key, message);
    } else if (type === 'success') {
      this.addSuccess(key, message);
    }
  }

  addAllFromMessageBag(messageBag) {
    this.errors.concat(messageBag.errors);
    this.warnings.concat(messageBag.warnings);
    this.success.concat(messageBag.success);
  }

  clearErrors() {
    this.errors.clear();
  }

  clearWarnings() {
    this.warnings.clear();
  }

  clearSuccess() {
    this.success.clear();
  }

  clear() {
    this.clearErrors();
    this.clearWarnings();
    this.clearSuccess();
  }

  get htmlErrorList() {
    const listItems = Object.keys(this.errors.messages)
      .map((x) => `<li>${this.errors.messages[x]}</li>`)
      .join('');
    const html = `<ul style="padding-left: 1.6rem; margin-top: 0.3rem;">${listItems}</ul>`;
    return html;
  }
}
